import { FormattedMessage } from 'react-intl';
import logWebHeaderUpgradeToProTapped from '@alltrails/amplitude/events/logWebHeaderUpgradeToProTapped';
import Button, { type ButtonProps } from '@alltrails/denali/components/Button';

type StartFreeTrialButtonProps = {
  onClick: () => void;
  variant?: ButtonProps['variant'];
};

const StartFreeTrialButton = ({ onClick, variant }: StartFreeTrialButtonProps) => (
  <Button
    onClick={() => {
      logWebHeaderUpgradeToProTapped({});
      onClick();
    }}
    size="sm"
    text={<FormattedMessage defaultMessage="Start free trial" />}
    variant={variant}
  />
);

export default StartFreeTrialButton;
